/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";

ko.components.register('summary-field', {
	viewModel: function(params) {
		params = params || {};
		var field = this.field = params.value.field;
		this.label = field.label;
		this.valueHtml = ko.pureComputed(() => field.formattedValueHtml());
	},
	template: require('../../templates/summary-field.html')
});
